export default __webpack_public_path__ + "static/media/down-arrow.c9a96020.svg";